<template>
  <card-container
    :id="pageId"
    :is-loading="isLoading"
    :disabled="isLoading"
    loading-message="Sending Receipt..."
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Send Receipt
    </template>

    <template #content>
      <div class="row align-items-center">
        <label class="col-sm-3 control-label"> Delivery Order Id* </label>
        <div class="col-sm-7">
          <sanitized-input
            id="orderId"
            v-model="orderId"
            placeholder="Order ID"
            required
          />
        </div>
      </div>
    </template>

    <template #submit-button>
      Send Receipt
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

import util from '@/Utils/util';
import { useSwalDialog } from '@/use/swalDialog';
import { useGlobal } from '@/use/global';
import { sendPost } from '@/Utils/api';

const pageId = 'send-delivery-receipt';

export default {
  name: 'SendDeliveryReceipt',

  setup: () => {
    const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();
    const { lastFormData, setFormData } = useGlobal(pageId);

    const orderId = ref('');
    const isLoading = ref(false);

    const submitForm = async () => {
      isLoading.value = true;
      try {
        const response = await sendPost('sendDeliveryReceipt', {
          orderId: orderId.value,
        });

        showSuccessPopupDialog({
          text: response.data.message,
        });
      } catch (error) {
        const errorText = util.getErrorResponse(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      isLoading.value = false;
    };

    const resetForm = () => {
      orderId.value = '';
    };

    onMounted(() => {
      orderId.value = lastFormData.value?.orderId || '';
    });

    onBeforeUnmount(() => {
      setFormData({
        orderId: orderId.value,
      });
    });

    return {
      pageId,
      orderId,
      isLoading,

      submitForm,
      resetForm,
    };
  },
};
</script>
